var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-white mt-20 mb-5"},[_c('Banner'),_c('CampaignCard'),_c('PartnerOrganization'),_c('Partners')],1),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555"},[_c('DownloadApp'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }